import { UploadCloud, Palette, ShieldCheck, Clock } from "lucide-react";
import { Reveal, SectionHeader } from "../Reveal";
import { CopyChecker } from "../CopyChecker";
import { DESIGN_FEE } from "../../lib/data";

export const FunnelCreative = () => (
    <section id="creative" className="relative bg-noir-surface py-24 sm:py-32 overflow-hidden" data-testid="funnel-creative">
        <div className="absolute inset-0 led-dots opacity-30" aria-hidden="true" />
        <div className="relative mx-auto max-w-[1200px] px-4 sm:px-6">
            <SectionHeader
                eyebrow="CREATIVE & AD DESIGN"
                title={<>YOUR ARTWORK. <span className="text-hotpink led-text-glow">BIG SCREEN READY.</span></>}
            />

            <Reveal>
                <div className="mx-auto max-w-3xl text-center rounded-2xl border-2 border-hotpink/60 bg-noir px-6 py-10 led-glow" data-testid="seven-word-rule">
                    <p className="font-display text-4xl sm:text-5xl font-extrabold text-white">7 WORDS OR LESS <span className="text-hotpink">+ LOGO</span></p>
                    <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-zinc-400">
                        Your main advertising message must contain no more than 7 words and must include your logo.
                        Every advertisement artwork must be reviewed and approved before it goes live.
                    </p>
                </div>
            </Reveal>

            <div className="mt-10 grid md:grid-cols-2 gap-6">
                <Reveal className="h-full">
                    <div className="card-media h-full p-8" data-testid="creative-own-design">
                        <UploadCloud size={26} className="text-hotpink" />
                        <h3 className="mt-4 font-display text-xl font-bold text-white">HAVE YOUR OWN DESIGN?</h3>
                        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                            Upload your finished advertisement with your quote request or campaign. Common image formats
                            such as PNG and JPG are accepted, subject to network requirements. Artwork must meet the
                            applicable technical and creative requirements of the selected advertising network.
                        </p>
                        <p className="mt-4 flex items-start gap-2 text-xs text-zinc-500">
                            <ShieldCheck size={15} className="text-hotpink shrink-0 mt-0.5" />
                            All artwork must be approved before going live. Submitting artwork does not guarantee immediate approval or immediate placement.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.1} className="h-full">
                    <div className="card-media h-full p-8 !border-hotpink/40" data-testid="creative-need-design">
                        <Palette size={26} className="text-hotpink" />
                        <h3 className="mt-4 font-display text-xl font-bold text-white">NEED HELP WITH YOUR DESIGN?</h3>
                        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                            Add custom billboard design for <strong className="text-white">+${DESIGN_FEE} per billboard</strong> —
                            custom high-quality design, professional advertising artwork, digital billboard-ready creative,
                            and an eye-catching presentation.
                        </p>
                        <p className="mt-4 rounded-lg border border-hotpink/30 bg-hotpink/[0.08] px-4 py-2.5 text-xs text-zinc-300">
                            The ${DESIGN_FEE} design fee is per billboard and becomes non-refundable once design work begins.
                        </p>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.15}>
                <div className="mx-auto mt-10 max-w-3xl">
                    <CopyChecker />
                </div>
            </Reveal>

            <Reveal delay={0.2}>
                <p className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-zinc-500" data-testid="creative-turnaround-note">
                    <Clock size={13} className="inline mr-1.5 text-hotpink" />
                    Turnaround times may vary based on artwork submission, revisions, approval processes, network
                    requirements, billboard/screen availability, campaign dates, and placement availability.
                </p>
            </Reveal>
        </div>
    </section>
);
